<div>
  <div class="wiz-content">
    <div class="wiz-content-text">
      <h1>{{ 'wizard.step-1.title' | translate }}</h1>
      <p>{{ 'wizard.step-1.p-1' | translate }}</p>
      <p>{{ 'wizard.step-1.p-2' | translate }}</p>
      <p>{{ 'wizard.step-1.p-3' | translate }} <a href="mailto:podpora@evidentist.cz">podpora&#64;evidentist.cz</a>.</p>
    </div>
    <button class="primary-btn" routerLink="/plugplay/step-2" (click)="setHighestLastStepCompleted.emit(0)">
      {{ 'wizard.step-1.btn-run' | translate }}
    </button>
  </div>
</div>
